import axios from 'axios';

export default axios.create({
  baseURL: 'https://funwithtasksapiapp.azurewebsites.net/api',
  // baseURL: process.env.REACT_APP_FUN_WITH_TASKS_API_ENDPOINT,
});
